export default {
  1 : {
    description: { en: 'Sunny', es: 'Soleado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/1.svg'
  },
  2: {
    description: { en: 'Mostly Sunny', es: 'Mayormente soleado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/2.svg'
  },
  3: {
    description: { en: 'Partly Sunny', es: 'Parcialmente soleado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/3.svg'
  },
  4: {
    description: { en: 'Intermittent Clouds', es: 'Nubes intermitentes'}, iconUrl: 'https://www.accuweather.com/images/weathericons/4.svg'
  },
  5: {
    description: { en: 'Hazy', es: 'Brumoso' }, iconUrl: 'https://www.accuweather.com/images/weathericons/5.svg'
  },
  6: {
    description: { en: 'Mostly Cloudy', es: 'Mayormente nublado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/6.svg'
  },
  7: {
    description: { en: 'Cloudy', es: 'Nublado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/7.svg'
  },
  8: {
    description: { en: 'Cloudy', es: 'Nublado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/8.svg'
  },
  9: {
    description: { en: 'Unknown', es: 'Desconocido' }, iconUrl: ''
  },
  10: {
    description: { en: 'Unknown', es: 'Desconocido' }, iconUrl: ''
  },
  11: {
    description: { en: 'Foggy', es: 'Neblinoso' }, iconUrl: 'https://www.accuweather.com/images/weathericons/11.svg'
  },
  12: {
    description: { en: 'Chance of Rain Showers', es: 'Probabilidad de lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/12.svg'
  },
  13: {
    description: { en: 'Mostly Cloudy w/ Showers', es: 'Mayormente nublado con lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/13.svg'
  },
  14: {
    description: { en: 'Partly Sunny w/ Showers', es: 'Parcialmente soleado con lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/14.svg'
  },
  15: {
    description: { en: 'Thunderstorms', es: 'Tormentas eléctricas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/15.svg'
  },
  16: {
    description: { en: 'Mostly Cloudy w/ Ttorms', es: 'Mayormente nublado con tormentas eléctricas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/16.svg'
  },
  17: {
    description: { en: 'Partly Sunny w/ Ttorms', es: 'Parcialmente soleado con tormentas eléctricas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/17.svg'
  },
  18: {
    description: { en: 'Rain', es: 'Lluvia' }, iconUrl: 'https://www.accuweather.com/images/weathericons/18.svg'
  },
  19: {
    description: { en: 'Flurries', es: 'Ráfagas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/19.svg'
  },
  20: {
    description: { en: 'Mostly Cloudy w/ Flurries', es: 'Mayormente nublado con ráfagas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/20.svg'
  },
  21: {
    description: { en: 'Partly Sunny w/ Flurries', es: 'Parcialmente soleado con ráfagas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/21.svg'
  },
  22: {
    description: { en: 'Snow', es: 'Nieve' }, iconUrl: 'https://www.accuweather.com/images/weathericons/22.svg'
  },
  23: {
    description: { en: 'Mostly Cloudy w/ Snow', es: 'Mayormente nublado con nieve' }, iconUrl: 'https://www.accuweather.com/images/weathericons/23.svg'
  },
  24: {
    description: { en: 'Ice', es: 'Hielo' }, iconUrl: 'https://www.accuweather.com/images/weathericons/24.svg'
  },
  25: {
    description: { en: 'Sleet', es: 'Aguanieve' }, iconUrl: 'https://www.accuweather.com/images/weathericons/25.svg'
  },
  26: {
    description: { en: 'Freezing Rain', es: 'Lluvia helada' }, iconUrl: 'https://www.accuweather.com/images/weathericons/26.svg'
  },
  27: {
    description: { en: 'Unknown', es: 'Desconocido' }, iconUrl: ''
  },
  28: {
    description: { en: 'Unknown', es: 'Desconocido' }, iconUrl: ''
  },
  29: {
    description: { en: 'Rain and Snow', es: 'Lluvia y Nieve'}, iconUrl: 'https://www.accuweather.com/images/weathericons/29.svg'
  },
  30: {
    description: { en: 'Hot', es: 'Caliente' }, iconUrl: 'https://www.accuweather.com/images/weathericons/30.svg'
  },
  31: {
    description: { en: 'Cold', es: 'Frio' }, iconUrl: 'https://www.accuweather.com/images/weathericons/31.svg'
  },
  32: {
    description: { en: 'Windy', es: 'Ventoso' }, iconUrl: 'https://www.accuweather.com/images/weathericons/32.svg'
  },
  33: {
    description: { en: 'Clear', es: 'Despejado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/33.svg'
  },
  34: {
    description: { en: 'Mostly Clear', es: 'Mayormente Despejado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/34.svg'
  },
  35: {
    description: { en: 'Partly Cloudy', es: 'Parcialmente nublado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/35.svg'
  },
  36: {
    description: { en: 'Intermittent Clouds', es: 'Nubes intermitentes'}, iconUrl: 'https://www.accuweather.com/images/weathericons/36.svg'
  },
  37: {
    description: { en: 'Hazy (Night)', es: 'Brumoso (Noche)' }, iconUrl: 'https://www.accuweather.com/images/weathericons/37.svg'
  },
  38: {
    description: { en: 'Mostly Cloudy', es: 'Mayormente nublado' }, iconUrl: 'https://www.accuweather.com/images/weathericons/38.svg'
  },
  39: {
    description: { en: 'Partly Cloudy w/ Showers', es: 'Parcialmente nublado con lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/39.svg'
  },
  40: {
    description: { en: 'Mostly Cloudy w/ Showers', es: 'Mayormente nublado con lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/40.svg'
  },
  41: {
    description: { en: 'Partly Cloudy w/ Ttorms', es: 'Parcialmente nublado con tormentas eléctricas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/40.svg'
  },
  42: {
    description: { en: 'Mostly Cloudy w/ Ttorms', es: 'Mayormente nublado con tormentas eléctricas' }, iconUrl: 'https://www.accuweather.com/images/weathericons/40.svg'
  },
  43: {
    description: { en: 'Mostly Cloudy w/ Flurries', es: 'Mayormente nublado con lluvias' }, iconUrl: 'https://www.accuweather.com/images/weathericons/43.svg'
  },
  44: {
    description: { en: 'Mostly Cloudy w/ Snow', es: 'Mayormente nublado con nieve' }, iconUrl: 'https://www.accuweather.com/images/weathericons/44.svg'
  }
}
